import { ComponentUtils } from '@/mixins';
import ShCard from '@/components/Helpers/ShCard';

// @vue/component
export default {
  name: 'WidgetButtonPreview',

  components: {
    ShCard,
  },

  mixins: [ComponentUtils],

  props: {
    widget: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: () => ({}),
    },
  },

  computed: {
    buttonPreviewPosition() {
      return this.mCopy.widget.style && (this.mCopy.widget.style.button_position === 'right' ? 'flex-end' : 'flex-start');
    },
  },

  created() {
    this.mMakeCopyFromProps('widget');
  },
};
